import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-6">
          <p className="text-sm text-designColor tracking-[4px]">2018- 2022</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="ST XAVIER Public School"
            subTitle="Intermediate(2018)"
            result="81%"
            des="Completed Intermediate education with a focus on core academic subjects, developing strong analytical and communication skills. Actively participated in school events and maintained consistent academic performance throughout the tenureThe training provided by universities in order to prepare people to work in various sectors of the economy or areas of culture."
          />
          <ResumeCard
            title="Arena Animation"
            subTitle="VFX AAIP  (2018 - 2022)"
            result="80%"
            des="Completed VFX AAIP with hands-on training in animation, compositing, and 3D tools. Gained practical experience through industry-relevant projects and creative work education is tertiary education leading to award of an academic degree. Higher education, also called post-secondary education."
          />
          {/* <ResumeCard
            title="Secondary School Education"
            subTitle="K.G.G.I.C (2015 - 2017)"
            result="70%"
            des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
          /> */}
        </div>
      </div>
      {/* part Two */}

      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-6">
          <p className="text-sm text-designColor tracking-[4px]">2018 - 2024</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
  <ResumeCard
    title="Motion Graphic Artist"
    // subTitle="Unicosmosoft pvt. Ltd - (2023 - Present)"
    result="Lucknow "
    des="Creative and dedicated motion graphic artist with one year of experience in developing dynamic animations and video content.
Proficient in Adobe After Effects and Premiere Pro, with a strong foundation in graphic design principles.
Seeking an opportunity to contribute to a forward-thinking media team."
  />
  <ResumeCard
    title="Graphic Designer"
    // subTitle="Cetpa Infotech pvt. ltd - (2022 - 2023)"
    result="Lucknow"
    des="Creative graphic designer with four years of experience in print and digital design.
Proficient in Adobe Creative Suite, specializing in branding, marketing materials, and political graphic.
Strong collaborative skills with a keen eye for detail and a passion for innovative design solutions."
  />
</div>

      </div>
    </motion.div>
  );
}

export default Education